import globalStyle from "../../../styles/globalStyle"

const userDataGridStyle = {

}


export default userDataGridStyle  